import React, { useEffect, useState } from 'react';
import { useExportDidsMutation } from '../services/requests';
import {useMsal} from "@azure/msal-react";

import {
    StyledExportButton,
    StyledCancelButton,
    StyledDialog,
    StyledExportDialogTitle,
    StyledDialogContent,
    StyledDialogContentText,
    StyledDialogActions,
    StyledCircularProgress
} from '../styles/mui_styles';

function ExportDIDDialog({ open, setOpen, ...rest }) {
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const email = activeAccount?.username;
    const [exportRequest, exportResponse] = useExportDidsMutation();
    const [isExporting, setIsExporting] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleExport = async () => {
        setIsExporting(true);
        setOpen(false);
        try {
            await exportRequest({ ...rest, email });
            window.dispatchEvent(new Event("startExport"));
        } catch (error) {
            setIsExporting(false);
            alert('Error during export, please try again.');
        }
    };

    useEffect(() => {
        if (exportResponse.data) {
            const anchor = document.createElement('a');
            anchor.href = exportResponse.data;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            setIsExporting(false);
        }
    }, [exportResponse.data]);

    return (
        <StyledDialog open={open} onClose={handleClose}>
            <StyledExportDialogTitle id="alert-dialog-title">
                Export DIDs
            </StyledExportDialogTitle>
            <StyledDialogContent>
                <StyledDialogContentText id="alert-dialog-description">
                    This will export only the DIDs currently filtered on the DIDs page. The export may take up to a couple of minutes.
                    The file will be ready in the <span className="highlighted"> File Manager</span> for you to download.
                </StyledDialogContentText>
            </StyledDialogContent>
            <StyledDialogActions>
                <StyledCancelButton onClick={handleClose} variant="outlined">
                    Cancel
                </StyledCancelButton>
                <StyledExportButton
                    variant="outlined"
                    onClick={handleExport}
                    disabled={isExporting}
                >
                    {isExporting ? <StyledCircularProgress size={24} /> : 'Export'}
                </StyledExportButton>
            </StyledDialogActions>
        </StyledDialog>
    );
}

export default React.memo(ExportDIDDialog);
